module.exports = __webpack_public_path__ + "img/magento-modules-customization.8e4dd7b0.webp";